class ProductVideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.bindEvents();
    this.isMobile = window.innerWidth <= 768;
    console.log('ProductVideoPlayer initialized', { isMobile: this.isMobile });
  }

  bindEvents() {
    this.addEventListener('click', this.handleClick.bind(this));
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth <= 768;
    });
    console.log('Events bound to', this);
  }

  handleClick(event) {
    console.log('Click event fired', event.target);
    
    // Don't interfere with native video controls
    if (event.target === this.video) {
      console.log('Clicked on video element, ignoring');
      return;
    }
    
    if (this.video.paused) {
      console.log('Playing video');
      this.video.play()
        .then(() => {
          // Only request fullscreen on mobile
          if (this.isMobile) {
            console.log('Mobile device detected, entering fullscreen');
            if (this.video.requestFullscreen) {
              return this.video.requestFullscreen();
            } else if (this.video.webkitRequestFullscreen) {
              return this.video.webkitRequestFullscreen();
            } else if (this.video.msRequestFullscreen) {
              return this.video.msRequestFullscreen();
            }
          }
        })
        .catch(error => console.error('Error playing video:', error));
    } else {
      console.log('Pausing video');
      this.video.pause();
    }
  }
}

customElements.define('product-video-player', ProductVideoPlayer);
